export default __webpack_public_path__ + "assets/climaider-2f2b2a0d89e0896321739d2699f074ea.svg";